export const loadCartItems = () => {
  try {
    const raw = sessionStorage.getItem("am_cart");
    if (!raw) return [];
    const payload = JSON.parse(raw);
    if (payload.items?.length) {
      return payload.items.map((i) => ({ key: i.label, category: payload.category, ...i }));
    }
    return [
      { key: payload.service, label: payload.service, labelBn: null, price: null, qty: 1, category: payload.category },
    ];
  } catch {
    return [];
  }
};

export const saveCartItems = (items) =>
  sessionStorage.setItem("am_cart", JSON.stringify({ category: items[0]?.category, items }));

export const clearCart = () => sessionStorage.removeItem("am_cart");
